import {
  Directive,
  Output,
  EventEmitter,
  HostBinding,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[appDnd]',
})
export class DndDirective {
  @HostBinding('class.fileover') fileOver: boolean;
  @Output() fileDropped = new EventEmitter<any>();
  @Output() hover = new EventEmitter<boolean>();

  private dragCounter = 0;

  // Dragenter listener: increment depth and emit true once when entering from 0
  @HostListener('dragenter', ['$event']) onDragEnter(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragCounter++;
    if (this.dragCounter === 1) {
      this.fileOver = true;
      this.hover.emit(true);
    }
  }

  // Dragover listener: required to allow drop
  @HostListener('dragover', ['$event']) onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  // Dragleave listener: decrement depth and only emit false when fully left (0)
  @HostListener('dragleave', ['$event']) onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragCounter = Math.max(0, this.dragCounter - 1);
    if (this.dragCounter === 0) {
      this.fileOver = false;
      this.hover.emit(false);
    }
  }

  // Drop listener: reset depth and emit false
  @HostListener('drop', ['$event']) onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.dragCounter = 0;
    this.fileOver = false;
    this.hover.emit(false);
    const files = evt.dataTransfer?.files;
    if (files && files.length > 0) {
      this.fileDropped.emit({ files, coords: [evt.offsetX, evt.offsetY] });
    }
  }

  // Dragend: safety reset in case drop occurs outside
  @HostListener('dragend') onDragEnd() {
    this.dragCounter = 0;
    this.fileOver = false;
    this.hover.emit(false);
  }
}
